module.exports = __webpack_public_path__ + "static/media/testi_10.562439c8.jpg";